import React from "react";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import { useState, useEffect, useLayoutEffect, useRef } from "react";
import useFetch from "../../../utils/useFetch";
import SectionTemplate from "../../../components/SectionTemplate";
import NavWrapper from "../../../components/QuestionnaireTemplate/NavWrapper";

import LoadingSpinner from "../../../toolkit/LoadingSpinner";
import ErrorAlert from "../../../toolkit/ErrorAlert";

// import BaseURL from '../../utils/base-uri.json';
import Button from "@mui/material/Button";
import MainInformation from "./MainInformation";
import BalanceSheetAssets from "./BalanceSheetAssets";
import AMhesh from "./Fina.json";
import FinancialDataSubSec from "./FinancialDataSubSec";
import LiabilitiesandEquity from "./LiabilitiesandEquity";
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import CloseIcon from '@mui/icons-material/Close';
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { Box } from "@mui/material";

const Labels = [
  {
    displayOrder: 0,
    isSectionCompleted: true,
    sectionId: 0,
    sectionName: "Main Information",
    sectionQuestions: null,
    sectionQuestionsCompleted: null,
    sectionType: 11,

  },
  {
    displayOrder: 1,
    isSectionCompleted: true,
    sectionId: 1,
    sectionName: "Balance Sheet Assets",
    sectionQuestions: null,
    sectionQuestionsCompleted: null,
    sectionType: 12,
  },
  {
    displayOrder: 2,
    isSectionCompleted: true,
    sectionId: 2,
    sectionName: "Liabilities and Equity",
    sectionQuestions: null,
    sectionQuestionsCompleted: null,
    sectionType: 13,
  },
  {
    displayOrder: 3,
    isSectionCompleted: true,
    sectionId: 3,
    sectionName: "Income Statement",
    sectionQuestions: null,
    sectionQuestionsCompleted: null,
    sectionType: 14,
  },
  {
    displayOrder: 4,
    isSectionCompleted: true,
    sectionId: 4,
    sectionName: "Select Financial Data",
    sectionQuestions: null,
    sectionQuestionsCompleted: null,
    sectionType: 15,
  },
];

function mapInitialData(r) {
  return {
    id: r.sectionId,
    text: r.sectionName,
    status: r.isSectionCompleted === true ? "completed" : "pending",
    sectionType: r.sectionType,
    metrics:
      r.sectionQuestions === 0
        ? null
        : r.sectionQuestionsCompleted + "/" + r.sectionQuestions,
    component: r.component,
    IsSectionCompleted: r.isSectionCompleted,

  };
}

function getComponent(name) {
  switch (name) {
    case 0:
      return MainInformation;
    case 2:
      return LiabilitiesandEquity;
    case 1:
      return BalanceSheetAssets;

    default:
      return MainInformation;
  }
}
export default function FinancialData({ remote, Pqid, handleClose1 }, selected) {

  const [sections, setSections] = useState([]);
  const [sectionId, setSectionId] = useState(0);
  const [section, setSection] = useState();
  const [first, setFirst] = useState();
  const [navProps, setNavProps] = useState({
    options: sections,
    onChange: (sectionId) => {
      setSectionId(sectionId);
    },
    variant: "stepperNav",
  });
  const [sectionQuestions, setSectionQuestions] = useState([]);
  const [hasFinancialData, setHasFinancialData] = useState(true);
  const [sectionQuestionsCompleted, setSectionQuestionsCompleted] = useState(
    []
  );
  useEffect(() => {
    setSection(sections.find((s) => s.id === sectionId));
  }, [sectionId]);

  useLayoutEffect(() => {
    setSectionId(sections[0]?.id);
  }, [navProps]);

  useEffect(() => {
    setNavProps((prev) => ({
      ...prev,
      options: sections,
    }));
  }, [sections]);

  useEffect(() => {
    Labels.forEach((q) => (q.component = getComponent(q.sectionType)));

    setSections(Labels.map(mapInitialData) || []);
    setSectionId(0);

    // setSectionQuestions(resp?.data?.reduce((a, r) => a = a + r.sectionQuestions, 0))
    // setSectionQuestionsCompleted(resp?.data?.reduce((a, r) => a = a + r.sectionQuestionsCompleted, 0))
  }, [Labels]);

  function setNextActive() {
    const cur = sections.find((f) => f.id === section.id);
    const next = sections[sections.indexOf(cur) + 1];
    if (next) {
      // setScrollTabIntoView(true);
      setSectionId(next.id);
    }
  }

  function setPrevActive() {
    const cur = sections.find((f) => f.id === section.id);
    const prev = sections[sections.indexOf(cur) - 1];
    if (prev) {
      // setScrollTabIntoView(true);
      setSectionId(prev.id);
    }
  }

  function fetchedFinancialDataEntry(data) {
    setHasFinancialData(data && data.length > 0);
  }  

  return (
    <div>
      < AppBar sx={{ position: 'relative', backgroundColor: "#1976d2" }
      }>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleClose1}
            aria-label="close"
            sx={{ color: "#fff" }}
          >
            <CloseIcon />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1, color: "#fff" }} variant="h6" component="div">
            Financial Data Entry
          </Typography>
        </Toolbar>
      </AppBar>

      <Box sx={{ padding: "20px" }}>
        {!hasFinancialData ? (
          <p style={{ color: "red", fontWeight: "600" }}>
            Please set the Financial year-end Month and Date under My
            Account&gt;&gt;Company Details
          </p>
        ) : (
          <div>
            <p style={{ color: "red" }}>
              IMPORTANT: IF TODAY'S DATE IS LESS THAN SIX MONTHS FROM YOUR
              PREVIOUS FISCAL YEAR-END, DO NOT ENTER FINANCIAL DATA IN THE
              CURRENT YTD COLUMN - ENTER ZEROS
            </p>
            <p style={{ color: "red", fontWeight: "600" }}>
              EVERY FIELD MUST BE COMPLETED (EVEN IF ZERO) -- USE ONLY WHOLE
              NUMBERS.
            </p>
            <p style={{ color: "red", fontWeight: "600" }}>
              To change a previously-saved value: Click on the field, press the
              "=" sign. Enter new number or formula, then press the Enter button
            </p>
            <p style={{ color: "red", fontWeight: "600" }}>
              For best results, Do not use Internet Explorer.
            </p>
            <p>
              **
              <span style={{ color: "red", fontWeight: "600" }}>
                are non-editable fields.
              </span>
            </p>
            <SectionTemplate
              style={{ marginleft: "40%" }}
              navWrapper={false}
              // ml={true}
              //  percentComplete={(sectionQuestionsCompleted / sectionQuestions * 100).toFixed(0)}
              percentComplete={84}
              //  leftLabel={sectionQuestionsCompleted + " Complete / Out of " + sectionQuestions + " Total Questions " + " ( " + (sectionQuestionsCompleted / sectionQuestions * 100).toFixed(0) + "% Complete" + " ) "}
              rightLabel={""}
              navProps={{
                ...navProps,
                selected: sectionId,
              }}
            >
              <FinancialDataSubSec
                IsSectionCompleted={section?.IsSectionCompleted}
                Secid={section?.id}
                SectionType={section?.sectionType}
                setNextSection={setNextActive}
                setPrevSection={setPrevActive}
                clicked={remote}
                Pqid={Pqid}
                handleClose={handleClose1}
                fetchedFinancialDataEntry={fetchedFinancialDataEntry}
              />
            </SectionTemplate>
          </div>
        )}
      </Box>
    </div>
  );
}